var $ = jQuery;

$('#videoPlayerModal').on('shown.bs.modal', function(e) {
    var $target = $(e.relatedTarget),
        $this = $(this),
        opt = {},
        video = $target.data('video'),
        title = $target.data('title'),
        endscreen = $target.next().find('.endscreen'),
        checkboxes = JSON.parse($target.attr('data-checkboxes'));


    for (i = 0; i < checkboxes.length; i++) {
        opt[checkboxes[i]] = 1;
    }
    opt['clip'] = {
        sources: [
            {
                type: "video/mp4",
                src: video
            }
        ]
    };
    opt.key="$832005150146727";

    $this.find(".modal-title").append(title);
    $this.find(".modal-body").append('<div class="video fp-edgy"></div>');
    $this.find(".video").flowplayer(opt);
    $.get(
        ajaxurl,
        {
            'action': 'textAfterVideo',
            'data': {'id': $target.data('id') }
        }).done(function (data) {
            $this.find(".video").prepend('<div class="endscreen">' + data +'</div>');
    });
}).on('hidden.bs.modal', function() {
    $(this).find(".modal-title").empty();
    $(this).find(".modal-body").empty();
});


$('.footer-links li.menu-item-has-children > a ').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('open');
    $(this).next().slideToggle();
})


$('.js-opennav').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.mobile-inner-navigation').slideToggle();
})

$('.js-toggle-solutions').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('span.less, span.more').toggleClass('active');
    $('.solution-items').slideToggle();
})
